import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import ContentLoader from "../../utils/ContentLoader";
import { customSelectStyles } from "../../utils/customizedStyles";
import { Tabs } from "antd";
import { mapPrayerRequestTypeOptions, PRAYER_REQUEST_TYPE_LABELS } from "../../utils/prayerRequestUtils";

const statusOptions = [
    {
        value: "pending",
        label: "Pending",
    },
    {
        value: "accepted",
        label: "Accepted",
    },
    {
        value: "rejected",
        label: "Rejected",
    },
];

export default function PrayerRequestForm({
    onSubmit,
    onCancel,
    initialData = {},
    prayerRequestTypeOptions = [],
}) {
    const isEdit = Boolean(initialData?.id);

    const [loading] = useState(false);
    const [errors, setErrors] = useState({});
    const [prayerRequestOptions, setprayerRequestOptions] = useState([]);
    const [formData, setFormData] = useState({
        notes: {
            tn: "",
            en: "",
        },
        prayerRequestTypeId: "",
        prayerRequestTypeOthers: "",
        likes: 0,
        status: "pending",
    });

    useEffect(() => {
        if (!prayerRequestTypeOptions?.length) return;
        setprayerRequestOptions(mapPrayerRequestTypeOptions(prayerRequestTypeOptions));
    }, [prayerRequestTypeOptions]);

    useEffect(() => {
        if (initialData?.id) {
            setFormData({
                notes: {
                    tn: initialData?.notes?.tn || "",
                    en: initialData?.notes?.en || "",
                },
                prayerRequestTypeId: initialData?.prayer_request_type_id || "",
                prayerRequestTypeOthers: initialData?.prayer_request_type_others || "",
                likes: initialData.likes || 0,
                status: initialData.status || "pending",
            });
        }
    }, [initialData]);

    const othersId = prayerRequestOptions.find(
        (item) => item.label === PRAYER_REQUEST_TYPE_LABELS.others
    )?.value;

    // =========================
    // CHANGE HANDLER
    // =========================
    const handleLangFieldChange = (field, lang, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: {
                ...prev[field],
                [lang]: value,
            },
        }));

        setErrors((prev) => ({
            ...prev,
            [`${field}_${lang}`]: "",
        }));
    };

    const updateField = (field, value) => {
        setFormData((prev) => {
            let updated = { ...prev, [field]: value };

            if (field === "prayerRequestTypeId" && value !== othersId) {
                updated.prayerRequestTypeOthers = "";
            }

            return updated;
        });

        setErrors((prev) => ({
            ...prev,
            [field]: "",
        }));
    };

    const validate = () => {
        const newErrors = {};

        const tamilFilled = formData.notes?.tn?.trim();
        const englishFilled = formData.notes?.en?.trim();

        if (!tamilFilled && !englishFilled) {
            newErrors.notes_tn = true;
            newErrors.notes_en = true;
        }

        if (!formData.prayerRequestTypeId) {
            newErrors.prayerRequestTypeId = true;
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) {
            toast.error("Please enter notes");
            return;
        }

        await onSubmit({
            ...formData,
            notes: JSON.stringify(formData.notes),
            prayer_request_type_id: formData.prayerRequestTypeId,
            prayer_request_type_others: formData.prayerRequestTypeOthers,
        });
    };

    if (loading) return <ContentLoader />;

    return (
        <div className="col-lg-12">
            <div className="card mt-3">
                <div className="card-header">
                    <h5 className="card-title">
                        {isEdit
                            ? "Edit Prayer Request"
                            : "Create Prayer Request"}
                    </h5>
                </div>

                <div className="card-body">
                    <form onSubmit={handleFormSubmit} className="row gy-3" >
                        <div className="col-12">
                            <Tabs
                                defaultActiveKey="tn"
                                items={[
                                    {
                                        key: "tn",
                                        label: "Tamil",
                                        children: (
                                            <div className="row gy-3">
                                                <div className="col-md-12">
                                                    <label className="form-label">
                                                        Notes <span className="text-danger">*</span>
                                                    </label>

                                                    <textarea
                                                        rows={5}
                                                        className={`form-control ${errors.notes_tn ? "is-invalid" : ""
                                                            }`}
                                                        placeholder="Enter Tamil Notes"
                                                        value={formData.notes.tn}
                                                        onChange={(e) =>
                                                            handleLangFieldChange(
                                                                "notes",
                                                                "tn",
                                                                e.target.value
                                                            )
                                                        }
                                                    />

                                                    {errors.notes_tn && (
                                                        <div className="invalid-feedback">
                                                            Tamil Notes is required
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ),
                                    },

                                    {
                                        key: "en",
                                        label: "English",
                                        children: (
                                            <div className="row gy-3">
                                                <div className="col-md-12">
                                                    <label className="form-label">
                                                        Notes <span className="text-danger">*</span>
                                                    </label>

                                                    <textarea
                                                        rows={5}
                                                        className={`form-control ${errors.notes_en ? "is-invalid" : ""
                                                            }`}
                                                        placeholder="Enter English Notes"
                                                        value={formData.notes.en}
                                                        onChange={(e) =>
                                                            handleLangFieldChange(
                                                                "notes",
                                                                "en",
                                                                e.target.value
                                                            )
                                                        }
                                                    />

                                                    {errors.notes_en && (
                                                        <div className="invalid-feedback">
                                                            English Notes is required
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ),
                                    },

                                    {
                                        key: "common",
                                        label: "Common",
                                        children: (
                                            <div className="row gy-3">

                                                {/* Prayer Request TYPE STYLE */}
                                                <div className="col-md-6">
                                                    <label className="form-label">
                                                        Prayer Request Type <span style={{ color: "red" }}>*</span>
                                                    </label>

                                                    <Select
                                                        options={prayerRequestOptions}
                                                        value={
                                                            prayerRequestOptions.find(
                                                                (option) =>
                                                                    option.value === formData.prayerRequestTypeId
                                                            ) || null
                                                        }
                                                        placeholder="Select Prayer Request Type"
                                                        onChange={(selected) => {
                                                            if (!selected) {
                                                                updateField("prayerRequestTypeId", "");
                                                                updateField("prayerRequestTypeOthers", "");
                                                                return;
                                                            }

                                                            updateField("prayerRequestTypeId", selected.value);

                                                            if (selected.value !== othersId) {
                                                                updateField("prayerRequestTypeOthers", "");
                                                            }
                                                        }}
                                                        styles={customSelectStyles()}
                                                    />

                                                    {errors.prayerRequestTypeId && (
                                                        <span className="text-danger">
                                                            Required
                                                        </span>
                                                    )}
                                                </div>

                                                {/* OTHERS FIELD */}
                                                {formData.prayerRequestTypeId === othersId && (
                                                    <div className="col-md-6">
                                                        <label className="form-label">
                                                            Other Prayer Request Type
                                                        </label>

                                                        <input
                                                            className="form-control"
                                                            placeholder="Enter Other Prayer Request Type"
                                                            value={formData.prayerRequestTypeOthers}
                                                            onChange={(e) =>
                                                                updateField(
                                                                    "prayerRequestTypeOthers",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />

                                                        {errors.prayerRequestTypeOthers && (
                                                            <span className="text-danger">
                                                                Required
                                                            </span>
                                                        )}
                                                    </div>
                                                )}

                                                {/* Likes */}
                                                <div className="col-md-6">
                                                    <label className="form-label">
                                                        Likes
                                                    </label>

                                                    <input
                                                        type="number"
                                                        min="0"
                                                        className="form-control no-spinner"
                                                        placeholder="Enter Likes Count"
                                                        value={formData.likes}
                                                        onChange={(e) =>
                                                            updateField(
                                                                "likes",
                                                                Number(e.target.value)
                                                            )
                                                        }
                                                    />
                                                </div>

                                                {/* Status */}
                                                <div className="col-md-6">
                                                    <label className="form-label">
                                                        Status
                                                    </label>

                                                    <Select
                                                        options={statusOptions}
                                                        value={statusOptions.find(
                                                            (option) =>
                                                                option.value === formData.status
                                                        )}
                                                        onChange={(selected) =>
                                                            updateField(
                                                                "status",
                                                                selected.value
                                                            )
                                                        }
                                                        styles={customSelectStyles()}
                                                    />
                                                </div>
                                            </div>
                                        ),
                                    },
                                ]}
                            />
                        </div>

                        <div className="col-12 d-flex justify-content-end gap-2">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={onCancel}
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                            >
                                {isEdit
                                    ? "Update Prayer Request"
                                    : "Create Prayer Request"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}